import { LegalEmail, LegalHeading, legalEntityDescription, LegalLayout } from './LegalLayout';

/**
 * Written from what the code actually stores, schema.sql is the source, not a
 * template. If a column is added that holds personal data, it belongs here.
 */
export function PrivacyPage() {
    return (
        <LegalLayout title="Privacy">
            <p>{legalEntityDescription()}, is responsible for the personal data described here.</p>

            <LegalHeading>What we hold about you</LegalHeading>
            <p>
                <span className="text-text">Your email address</span>, because it is both your account name and how you
                sign in.
            </p>
            <p>
                <span className="text-text">Your plan and usage</span>: which tier you're on, whether you have used a
                paid-plan trial, trial end date if any, your Stripe customer and subscription identifiers if you've paid,
                and a monthly count of how many API requests you've made. Your card details are held by Stripe, never by
                us.
            </p>
            <p>
                <span className="text-text">Sign-in tokens and API keys</span>, stored only as one-way hashes, so a copy
                of our database does not hand anyone a working login or a live key.
            </p>
            <p>
                We do <span className="text-text">not</span> store the keywords, sellers or categories you search for.
                Every <code className="font-mono text-xs">/v1/*</code> request is fetched live and answered; nothing
                about its content is logged, only that it happened, for billing.
            </p>
            <p>We do not run advertising trackers, and we do not sell or share your data with anyone for marketing.</p>

            <LegalHeading>Who else processes it</LegalHeading>
            <p>
                <span className="text-text">Stripe</span> for payments and billing.{' '}
                <span className="text-text">Resend</span> for delivering sign-in emails.{' '}
                <span className="text-text">Cloudflare</span> for hosting and the database.{' '}
                <span className="text-text">Apify</span> for running the scraper that fetches eBay pages on your behalf.
                Apify receives the search terms in a request, never your identity.
            </p>
            <p>
                All four are outside Malaysia, so running this service means your account data is stored and processed
                abroad, mainly in the United States and the European Union. We only use providers that contract to
                protect it to a comparable standard. If that is not acceptable to you, the service is not usable without
                it.
            </p>

            <LegalHeading>How long we keep it</LegalHeading>
            <p>
                Account data lasts as long as your account does. Ask us to delete it and we will, except where we have
                to keep payment records for tax and accounting.
            </p>

            <LegalHeading>Cookies</LegalHeading>
            <p>
                One cookie, holding your session, set when you sign in to this console. No analytics or advertising
                cookies. There is nothing to consent to because there is nothing optional.
            </p>

            <LegalHeading>Your rights</LegalHeading>
            <p>
                You can ask for a copy of what we hold, ask us to correct it, or ask us to delete it. Email{' '}
                <LegalEmail /> and we'll deal with it.
            </p>
            <p>
                We operate from Malaysia and handle personal data in line with the Personal Data Protection Act 2010. If
                we don't resolve something to your satisfaction you can complain to the Personal Data Protection
                Commissioner (Jabatan Perlindungan Data Peribadi). If you're in the UK, EU or elsewhere, you may have
                equivalent rights and your own authority to complain to.
            </p>

            <LegalHeading>Contact</LegalHeading>
            <p>
                <LegalEmail />
            </p>
        </LegalLayout>
    );
}
